import {
  ExclamationCircleOutlined,
  LockTwoTone,
  UnlockTwoTone,
} from "@ant-design/icons";
import {
  Button,
  Divider,
  Layout,
  message,
  notification,
  Radio,
  Skeleton,
  Space,
  Timeline,
} from "antd";
import confirm from "antd/lib/modal/confirm";
import { Observer } from "mobx-react-lite";
import moment from "moment";
import React, { createContext, useContext, useEffect } from "react";
import { AlertTriangle, Edit3, Lock, User } from "react-feather";
import _ from "underscore";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import MonthlyPerformanceStore from "../../monthly-performance/store/monthlyperformancestore";
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const { Content } = Layout;
export const ProductionLock = () => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  useEffect(() => {
    async function loadUploadStatus() {
      await monthlyPerformanceStore.loadUploadStatus();
    }
    loadUploadStatus();
  });
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Content>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <SubPageHeaderTitle title="Manage Production Data Locks" />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {monthlyPerformanceStore.isLoadingStatus ? (
                    <>
                      <Skeleton active />
                      <Skeleton active />
                      <Skeleton active />
                      <Skeleton active />
                    </>
                  ) : (
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <Divider>Production Years</Divider>
                        </div>
                      </div>
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Observer>
                            {() => (
                              <Radio.Group
                                defaultValue={
                                  monthlyPerformanceStore.statusYear
                                }
                                size="large"
                                optionType="button"
                                buttonStyle="solid"
                                defaultChecked
                                onChange={({ target }) => {
                                  monthlyPerformanceStore.statusYear =
                                    target.value;
                                }}
                              >
                                {_.uniq(
                                  [
                                    ...monthlyPerformanceStore.uploadStatusItems.values(),
                                  ].map((item) => item.prodYear)
                                ).map((prodYear) => (
                                  <Radio.Button value={prodYear} key={prodYear}>
                                    {prodYear}
                                  </Radio.Button>
                                ))}
                              </Radio.Group>
                            )}
                          </Observer>
                        </div>
                      </div>
                      <Divider>Monthly Production Data Lock Status</Divider>
                      <Observer>
                        {() => (
                          <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                              {
                                <Timeline mode={"left"}>
                                  {_.where(
                                    [
                                      ...monthlyPerformanceStore.uploadStatusItems.values(),
                                    ],
                                    {
                                      prodYear:
                                        monthlyPerformanceStore.statusYear,
                                    }
                                  ).map((item) => (
                                    <Timeline.Item
                                      label={item.monthName}
                                      color={
                                        item.dataLockStatus === 2
                                          ? "green"
                                          : "red"
                                      }
                                      key={item.monthlyProductionLockId}
                                    >
                                      <div className="ms-Grid" dir="ltr">
                                        <div className="ms-Grid-row">
                                          <div
                                            className="ms-Grid-col ms-sm2"
                                            title={
                                              item.dataLockStatus === 2
                                                ? "Production data is locked and cannot be modified"
                                                : "Production data is opened to modifications"
                                            }
                                          >
                                            {item.dataLockStatus === 2 ? (
                                              <Lock color="green" />
                                            ) : (
                                              <AlertTriangle color="red" />
                                            )}
                                          </div>
                                          <div
                                            className="ms-Grid-col ms-sm3"
                                            title={
                                              item.dataLockStatus === 2
                                                ? "Locked By"
                                                : "Uploaded By"
                                            }
                                          >
                                            <User />
                                            {item.lockedBy}
                                          </div>
                                          <div
                                            className="ms-Grid-col ms-sm2"
                                            title={
                                              item.dataLockStatus === 2
                                                ? `Locked On ${moment(
                                                    item.lockedOn
                                                  ).format("LLLL")}`
                                                : `Uploaded On ${moment(
                                                    item.lockedOn
                                                  ).format("LLLL")}`
                                            }
                                          >
                                            {moment(item.lockedOn).fromNow()}
                                          </div>
                                          <div className="ms-Grid-col ms-sm4">
                                            <Space>
                                              <Button
                                                type={
                                                  item.dataLockStatus === 1
                                                    ? "primary"
                                                    : "danger"
                                                }
                                                onClick={async () => {
                                                  confirm({
                                                    icon:
                                                      item.dataLockStatus ===
                                                      1 ? (
                                                        <LockTwoTone />
                                                      ) : (
                                                        <UnlockTwoTone />
                                                      ),
                                                    title:
                                                      "Lock Production Data",
                                                    content: (
                                                      <div
                                                        className="ms-Grid"
                                                        dir="ltr"
                                                        style={{
                                                          padding: "10px",
                                                        }}
                                                      >
                                                        <div className="ms-Grid-row">
                                                          <div className="ms-Grid-col ms-sm12">
                                                            {`Confirm ${
                                                              item.dataLockStatus ===
                                                              1
                                                                ? "data Lock"
                                                                : "data unlock"
                                                            } for  ${
                                                              item.monthName
                                                            }-${
                                                              item.prodYear
                                                            } production data `}
                                                          </div>
                                                        </div>
                                                        <div className="ms-Grid-row">
                                                          <div
                                                            className="ms-Grid-col ms-sm12"
                                                            style={{
                                                              fontStyle:
                                                                "italic",
                                                              padding: "10px",
                                                            }}
                                                          >
                                                            <ExclamationCircleOutlined
                                                              style={{
                                                                color: "red",
                                                              }}
                                                            />{" "}
                                                            this operation will
                                                            be logged
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ),
                                                    onOk: async () => {
                                                      try {
                                                        let prodMonth = `${item.prodMonth}`;
                                                        if (
                                                          prodMonth.length === 1
                                                        ) {
                                                          prodMonth = `0${item.prodMonth}`;
                                                        }
                                                        const lockDate = moment(
                                                          `${item.prodYear}${prodMonth}10`,
                                                          "YYYYMMDD"
                                                        );
                                                        console.log(lockDate);

                                                        if (lockDate.isValid()) {
                                                          monthlyPerformanceStore.queryCriteria.startDate =
                                                            lockDate.toDate();

                                                          let lock =
                                                            item.dataLockStatus ===
                                                            1
                                                              ? true
                                                              : false;
                                                          const retVal =
                                                            await monthlyPerformanceStore.lockProduction(
                                                              lock
                                                            );
                                                          monthlyPerformanceStore.uploadStatusItems.set(
                                                            item.monthlyProductionLockId,
                                                            retVal
                                                          );

                                                          message.success(
                                                            `${
                                                              item.monthName
                                                            }-${
                                                              item.prodYear
                                                            } Production records ${
                                                              item.dataLockStatus ===
                                                              1
                                                                ? "Production data is locked and cannot be modified"
                                                                : "opened for modifications"
                                                            } successfully`
                                                          );
                                                        } else {
                                                          message.info(
                                                            "select a valid production month"
                                                          );
                                                        }
                                                      } catch (error) {
                                                        notification.error({
                                                          message:
                                                            "SPARS Feedback",
                                                          description:
                                                            error.message,
                                                        });
                                                      }
                                                    },
                                                    onCancel() {
                                                      console.log("Cancel");
                                                    },
                                                  });
                                                }}
                                              >
                                                {item.dataLockStatus === 1
                                                  ? "Lock Production Data"
                                                  : "UnLock Production Data"}
                                              </Button>
                                            </Space>
                                          </div>
                                        </div>
                                      </div>
                                    </Timeline.Item>
                                  ))}
                                </Timeline>
                              }
                            </div>
                          </div>
                        )}
                      </Observer>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

